import type {ReactElement} from 'react';
import {useState} from 'react';
import {Icon} from '@Components/icon-v2';
import {IconSize} from '@Components/icon-v2/icon.types';
import {getFaviconUrl} from './web-source-favicon.library';
import type {WebSourceFaviconProps} from './web-source-favicon.types';
import styles from './web-source-favicon.module.scss';

/** A cited site's favicon, falling back to a globe when the image cannot load. Decorative: the domain is always shown as text nearby. */
export function WebSourceFavicon({domain, className}: WebSourceFaviconProps): ReactElement {
  const [hasFailedToLoad, setHasFailedToLoad] = useState(false);

  if (hasFailedToLoad) {
    return (
      <span className={`${styles.webSourceFaviconFallback} ${className}`}>
        <Icon icon="icon-globe" size={IconSize.SIZE_ICON_12} />
      </span>
    );
  }

  return (
    <img
      className={`${styles.webSourceFavicon} ${className}`}
      src={getFaviconUrl(domain)}
      alt=""
      loading="lazy"
      referrerPolicy="no-referrer"
      onError={(): void => {
        setHasFailedToLoad(true);
      }}
    />
  );
}
